import * as Yup from 'yup'
import clsx from 'clsx'
import { FastField, Form, Formik, FormikProps } from 'formik'
import { useNavigate } from 'react-router-dom'

import { ResetPassword } from '../../types/sign-in'

import FormikInput from '../FormikInput'
import Spinner from '../Spinner'
import authService from '../../services/authService'
import toast from 'react-hot-toast'

const schema = Yup.object().shape({
  email: Yup.string().email('Must be a valid email').required('Email is required'),
})

const initialValues: ResetPassword = {
  email: '',
}

const ResetPasswordForm = () => {
  const navigate = useNavigate()

  const handleOnSubmit = async (values: ResetPassword): Promise<void> => {
    try {
      await authService.requestPasswordReset(values)

      toast.success('Password reset email sent! Please check your inbox.')
      navigate('/auth/login')
    } catch {
      toast.error('Error occurred while sending reset email.')
    }
  }
  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={schema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={handleOnSubmit}
    >
      {({ isSubmitting }: FormikProps<ResetPassword>) => (
        <Form className="space-y-6" noValidate>
          <fieldset disabled={isSubmitting}>
            <div className="space-y-3">
              <FastField
                type="email"
                name="email"
                component={FormikInput}
                label="Email"
                autoComplete="username"
                autoFocus
              />
            </div>
          </fieldset>

          <div>
            <button
              className={clsx({
                'btn btn-primary btn-full': true,
              })}
              disabled={isSubmitting}
            >
              {isSubmitting ? <Spinner className="trailing-icon h-4 w-4" /> : 'Reset Password'}
            </button>
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default ResetPasswordForm
